// getter
export const GETTERS_PROGRAM_ACTIVITIES_AVAILABLE =
  "GETTERS_PROGRAM_ACTIVITIES_AVAILABLE";
export const GETTERS_PROGRAM_ACTIVITIES_AVAILABLE_PAGINATION =
  "GETTERS_PROGRAM_ACTIVITIES_AVAILABLE_PAGINATION";
export const GETTERS_GET_PROGRAM_ACTIVITY_AVAILABLE =
  "GETTERS_GET_PROGRAM_ACTIVITY_AVAILABLE";

export const GETTERS_PROGRAM_ACTIVITIES_CUSTOM =
  "GETTERS_PROGRAM_ACTIVITIES_CUSTOM";
export const GETTERS_PROGRAM_ACTIVITIES_CUSTOM_PAGINATION =
  "GETTERS_PROGRAM_ACTIVITIES_CUSTOM_PAGINATION";

export const GETTERS_PROGRAM_ACTIVITIES_LEVEL_UNASSIGNED =
  "GETTERS_PROGRAM_ACTIVITIES_LEVEL_UNASSIGNED";
export const GETTERS_PROGRAM_ACTIVITIES_LEVEL_UNASSIGNED_PAGINATION =
  "GETTERS_PROGRAM_ACTIVITIES_LEVEL_UNASSIGNED_PAGINATION";
export const GETTERS_PROGRAM_ACTIVITIES_LEVEL_ASSIGNED =
  "GETTERS_PROGRAM_ACTIVITIES_LEVEL_ASSIGNED";
export const GETTERS_PROGRAM_ACTIVITIES_LEVEL_ASSIGNED_PAGINATION =
  "GETTERS_PROGRAM_ACTIVITIES_LEVEL_ASSIGNED_PAGINATION";
export const GETTERS_PROGRAM_ACTIVITIES_LEVELS =
  "GETTERS_PROGRAM_ACTIVITIES_LEVELS";
// export const GETTERS_ALL_PROGRAM_ACTIVITIES = 'GETTERS_ALL_PROGRAM_ACTIVITIES';
export const GETTERS_PROGRAM_ACTIVITIES_SUMMARY =
  "GETTERS_PROGRAM_ACTIVITIES_SUMMARY";
export const GETTERS_PROGRAM_ACTIVITIES_SUMMARY_PAGINATION =
  "GETTERS_PROGRAM_ACTIVITIES_SUMMARY_PAGINATION";

export const GETTERS_GET_PROGRAM_ACTIVITY_CUSTOM =
  "GETTERS_GET_PROGRAM_ACTIVITY_CUSTOM";

export const GETTERS_PROGRAM_ACTIVITY_PHASES =
  "GETTERS_PROGRAM_ACTIVITY_PHASES";
export const GETTERS_PROGRAM_ACTIVITY_TEMPLATES =
  "GETTERS_PROGRAM_ACTIVITY_TEMPLATES";
export const GETTERS_PROGRAM_ACTIVITY_TEMPLATES_PAGINATION =
  "GETTERS_PROGRAM_ACTIVITY_TEMPLATES_PAGINATION";
export const GETTERS_PROGRAM_AVAILABLE_ACTIVITIES_EMPLOYER_VERIFIED =
  "GETTERS_PROGRAM_AVAILABLE_ACTIVITIES_EMPLOYER_VERIFIED";
export const GETTERS_PROGRAM_AVAILABLE_ACTIVITIES_EMPLOYER_VERIFIED_PAGINATION =
  "GETTERS_PROGRAM_AVAILABLE_ACTIVITIES_EMPLOYER_VERIFIED_PAGINATION";
export const GETTERS_PROGRAM_ACTIVITY_LEVELS =
  "GETTERS_PROGRAM_ACTIVITY_LEVELS";
export const GETTERS_PROGRAM_ACTIVITY_LEVELS_CLONE =
  "GETTERS_PROGRAM_ACTIVITY_LEVELS_CLONE";
export const GETTERS_GET_PROGRAM_CALENDAR_ACTIVITY_MODAL_OPEN =
  "GETTERS_GET_PROGRAM_CALENDAR_ACTIVITY_MODAL_OPEN";
export const GETTERS_GET_ALL_PROGRAM_ACTIVITIES_DETAIL =
  "GETTERS_GET_ALL_PROGRAM_ACTIVITIES_DETAIL";
export const GETTERS_GET_CALENDAR_PHASE_SELECTED_ID =
  "GETTERS_GET_CALENDAR_PHASE_SELECTED_ID";
export const GETTERS_GET_LES_MILLS_RESOURCE = "GETTERS_GET_LES_MILLS_RESOURCE";

// action
export const ACTION_ADD_PROGRAM_ACTIVITY_PHASE =
  "ACTION_ADD_PROGRAM_ACTIVITY_PHASE";
export const ACTION_EDIT_PROGRAM_ACTIVITY_PHASE =
  "ACTION_EDIT_PROGRAM_ACTIVITY_PHASE";
export const ACTION_ADD_ACTIVITY_TO_PHASE = "ACTION_ADD_ACTIVITY_TO_PHASE";
export const ACTION_MOVE_ACTIVITY_TO_PHASE = "ACTION_MOVE_ACTIVITY_TO_PHASE";
export const ACTION_SAVE_PROGRAM_ACTIVITY_PHASE =
  "ACTION_SAVE_PROGRAM_ACTIVITY_PHASE";
export const ACTION_GET_PROGRAM_ACTIVITY_PHASES =
  "ACTION_GET_PROGRAM_ACTIVITY_PHASES";
export const ACTION_GET_ACTIVITIES_BY_PHASE_ID =
  "ACTION_GET_ACTIVITIES_BY_PHASE_ID";
export const ACTION_DELETE_PROGRAM_ACTIVITY_PHASE =
  "ACTION_DELETE_PROGRAM_ACTIVITY_PHASE";
export const ACTION_GET_PROGRAM_ACTIVITY_TEMPLATES =
  "ACTION_GET_PROGRAM_ACTIVITY_TEMPLATES";
export const ACTION_REFRESH_PHASE_AFTER_DELETION =
  "ACTION_REFRESH_PHASE_AFTER_DELETION";
export const ACTION_GET_ACTIVITIES_BY_LEVEL_ID =
  "ACTION_GET_ACTIVITIES_BY_LEVEL_ID";
export const ACTION_GET_PROGRAM_ACTIVITIES_UNASSIGNED_TO_LEVEL =
  "ACTION_GET_PROGRAM_ACTIVITIES_UNASSIGNED_TO_LEVEL";
export const ACTION_INIT_PROGRAM_ACTIVITIES_LEVEL =
  "ACTION_INIT_PROGRAM_ACTIVITIES_LEVEL";
export const ACTION_SET_ACTIVITIES_TO_LEVEL = "ACTION_SET_ACTIVITIES_TO_LEVEL";

export const ACTION_GET_PROGRAM_ACTIVITIES_AVAILABLE =
  "ACTION_GET_PROGRAM_ACTIVITIES_AVAILABLE";
export const ACTION_GET_PROGRAM_ACTIVITY_AVAILABLE =
  "ACTION_GET_PROGRAM_ACTIVITY_AVAILABLE";
export const ACTION_UPDATE_PROGRAM_ACTIVITY_CUSTOM =
  "ACTION_UPDATE_PROGRAM_ACTIVITY_CUSTOM";
export const ACTION_UPDATE_PROGRAM_PHASE_ACTIVITY_CUSTOM =
  "ACTION_UPDATE_PROGRAM_PHASE_ACTIVITY_CUSTOM";
export const ACTION_DELETE_PROGRAM_ACTIVITY_CUSTOM =
  "ACTION_DELETE_PROGRAM_ACTIVITY_CUSTOM";
export const ACTION_GET_PROGRAM_ACTIVITIES_CUSTOM =
  "ACTION_GET_PROGRAM_ACTIVITIES_CUSTOM";
export const ACTION_GET_PROGRAM_ACTIVITY_CUSTOM =
  "ACTION_GET_PROGRAM_ACTIVITY_CUSTOM";
export const ACTION_GET_PROGRAM_ACTIVITY_CUSTOM_TEMPLATE =
  "ACTION_GET_PROGRAM_ACTIVITY_CUSTOM_TEMPLATE";

export const ACTION_CLEAR_PROGRAM_ACTIVITIES_CUSTOM =
  "ACTION_CLEAR_PROGRAM_ACTIVITIES_CUSTOM";
export const ACTION_BULK_ADD_PROGRAM_CUSTOM_ACTIVITIES =
  "ACTION_BULK_ADD_PROGRAM_CUSTOM_ACTIVITIES";
export const ACTION_BULK_DELETE_PROGRAM_CUSTOM_ACTIVITIES =
  "ACTION_BULK_DELETE_PROGRAM_CUSTOM_ACTIVITIES";
export const ACTION_GET_PROGRAM_ACTIVITIES_LEVEL_UNASSIGNED =
  "ACTION_GET_PROGRAM_ACTIVITIES_LEVEL_UNASSIGNED";
export const ACTION_GET_PROGRAM_ACTIVITIES_LEVEL_ASSIGNED =
  "ACTION_GET_PROGRAM_ACTIVITIES_LEVEL_ASSIGNED";
export const ACTION_SET_PROGRAM_ACTIVITIES_STATE =
  "ACTION_SET_PROGRAM_ACTIVITIES_STATE";
export const ACTION_SET_ACTIVITY_TO_LEVEL = "ACTION_SET_ACTIVITY_TO_LEVEL";
export const ACTION_GET_ALL_PROGRAM_ACTIVITIES =
  "ACTION_GET_ALL_PROGRAM_ACTIVITIES";
export const ACTION_GET_PROGRAM_ACTIVITIES_SUMMARY =
  "ACTION_GET_PROGRAM_ACTIVITIES_SUMMARY";
export const ACTION_SET_DEFAULT_PROGRAM_ACTIVITIES_SUMMARY =
  "ACTION_SET_DEFAULT_PROGRAM_ACTIVITIES_SUMMARY";
export const ACTION_SET_PROGRAM_CALENDAR_ACTIVITY_MODAL_OPEN =
  "ACTION_SET_PROGRAM_CALENDAR_ACTIVITY_MODAL_OPEN";
export const ACTION_GET_AVAILABLE_ACTIVITIES_EMPLOYER_VERIFIED = "ACTION_GET_AVAILABLE_ACTIVITIES_EMPLOYER_VERIFIED";
export const ACTION_GET_ALL_ACTIVITY_TEMPLATES =
  "ACTION_GET_ALL_ACTIVITY_TEMPLATES";
export const ACTION_BULK_EDIT_PROGRAM_CUSTOM_ACTIVITIES =
  "ACTION_BULK_EDIT_PROGRAM_CUSTOM_ACTIVITIES";
export const ACTION_GET_ALL_ACTIVITY_CUSTOM_BY_PROGRAMID =
  "ACTION_GET_ALL_ACTIVITY_CUSTOM_BY_PROGRAMID";
export const ACTION_GET_ALL_ACTIVITY_CUSTOM_DETAIL_BY_PROGRAMID =
  "ACTION_GET_ALL_ACTIVITY_CUSTOM_DETAIL_BY_PROGRAMID";
export const ACTION_SAVE_PROGRAM_ACTIVITIES = "ACTION_SAVE_PROGRAM_ACTIVITIES";
export const ACTION_SEARCH_PROGRAM_ACTIVITIES =
  "ACTION_SEARCH_PROGRAM_ACTIVITIES";
export const ACTION_GET_LES_MILLS_RESOURCE = "ACTION_GET_LES_MILLS_RESOURCE";

// mutation
export const MUTATION_SET_PROGRAM_ACTIVITY_PHASE =
  "MUTATION_SET_PROGRAM_ACTIVITY_PHASE";
export const MUTATION_SET_PROGRAM_ACTIVITY = "MUTATION_SET_PROGRAM_ACTIVITY";
export const MUTATION_SET_PROGRAM_ACTIVITIES_AVAILABLE =
  "MUTATION_SET_PROGRAM_ACTIVITIES_AVAILABLE";
export const MUTATION_SET_PROGRAM_ACTIVITY_AVAILABLE =
  "MUTATION_SET_PROGRAM_ACTIVITY_AVAILABLE";
export const MUTATION_SET_PROGRAM_ACTIVITIES_CUSTOM =
  "MUTATION_SET_PROGRAM_ACTIVITIES_CUSTOM";
export const MUTATION_SET_PROGRAM_ACTIVITY_CUSTOM =
  "MUTATION_SET_PROGRAM_ACTIVITY_CUSTOM";
export const MUTATION_CLEAR_PROGRAM_ACTIVITIES_CUSTOM =
  "MUTATION_CLEAR_PROGRAM_ACTIVITIES_CUSTOM";
export const MUTATION_SET_PROGRAM_ACTIVITIES_LEVEL_UNASSIGNED =
  "MUTATION_SET_PROGRAM_ACTIVITIES_LEVEL_UNASSIGNED";
export const MUTATION_SET_PROGRAM_ACTIVITIES_LEVEL_ASSIGNED =
  "MUTATION_SET_PROGRAM_ACTIVITIES_LEVEL_ASSIGNED";
export const MUTATION_SET_PROGRAM_ACTIVITIES_STATE =
  "MUTATION_SET_PROGRAM_ACTIVITIES_STATE";
export const MUTATION_SET_ALL_PROGRAM_ACTIVITIES =
  "MUTATION_SET_ALL_PROGRAM_ACTIVITIES";
export const MUTATION_SET_PROGRAM_ACTIVITIES_SUMMARY =
  "MUTATION_SET_PROGRAM_ACTIVITIES_SUMMARY";
export const MUTATION_SET_PROGRAM_ACTIVITY_PHASES =
  "MUTATION_SET_PROGRAM_ACTIVITY_PHASES";
export const MUTATION_ADD_PROGRAM_ACTIVITY_PHASE =
  "MUTATION_ADD_PROGRAM_ACTIVITY_PHASE";
export const MUTATION_DELETE_PROGRAM_ACTIVITY_PHASE =
  "MUTATION_DELETE_PROGRAM_ACTIVITY_PHASE";
export const MUTATION_SET_PROGRAM_ACTIVITY_TEMPLATES =
  "MUTATION_SET_PROGRAM_ACTIVITY_TEMPLATES";
export const MUTATION_SET_AVAILABLE_ACTIVITIES_EMPLOYER_VERIFIED =
  "MUTATION_SET_AVAILABLE_ACTIVITIES_EMPLOYER_VERIFIED";
export const MUTATION_RESET_PROGRAM_ACTIVITY_TEMPLATES =
  "MUTATION_RESET_PROGRAM_ACTIVITY_TEMPLATES";
export const MUTATION_SET_PROGRAM_ACTIVITIES_BY_PHASE =
  "MUTATION_SET_PROGRAM_ACTIVITIES_BY_PHASE";
export const MUTATION_REFRESH_PHASE_AFTER_DELETION =
  "MUTATION_REFRESH_PHASE_AFTER_DELETION";
export const MUTATION_SET_PROGRAM_ACTIVITIES_BY_LEVEL =
  "MUTATION_SET_PROGRAM_ACTIVITIES_BY_LEVEL";
export const MUTATION_SET_PROGRAM_ACTIVITIES_CLONE_BY_LEVEL =
  "MUTATION_SET_PROGRAM_ACTIVITIES_CLONE_BY_LEVEL";

export const MUTATION_SET_LEVEL_LIST = "MUTATION_SET_LEVEL_LIST";
export const MUTATION_SET_DEFAULT_PROGRAM_ACTIVITIES_SUMMARY =
  "MUTATION_SET_DEFAULT_PROGRAM_ACTIVITIES_SUMMARY";
export const MUTATION_SET_PROGRAM_CALENDAR_ACTIVITY_MODAL_OPEN =
  "MUTATION_SET_PROGRAM_CALENDAR_ACTIVITY_MODAL_OPEN";

export const ACTION_GET_PROGRAM_ACTIVITIES_DETAILS =
  "ACTION_GET_PROGRAM_ACTIVITIES_DETAILS";
export const MUTATION_SET_PROGRAM_ACTIVITIES_DETAIL =
  "MUTATION_SET_PROGRAM_ACTIVITIES_DETAIL";

export const GETTERS_PROGRAM_ACTIVITIES_DETAIL =
  "GETTERS_PROGRAM_ACTIVITIES_DETAIL";
export const GETTERS_PROGRAM_TEMPLATE_ACTIVITIES_DETAIL =
  "GETTERS_PROGRAM_TEMPLATE_ACTIVITIES_DETAIL";
export const GETTERS_PROGRAM_ACTIVITIES_LIST =
  "GETTERS_PROGRAM_ACTIVITIES_LIST";
export const GETTERS_LEVEL_ACTIVITIES_FILTERS =
  "GETTERS_LEVEL_ACTIVITIES_FILTERS";
export const MUTATION_SET_LEVEL_ACTIVITIES_FILTERS =
  "MUTATION_SET_LEVEL_ACTIVITIES_FILTERS";
export const GETTERS_LEVEL_ACTIVITIES_MODAL_FILTERS =
  "GETTERS_LEVEL_ACTIVITIES_MODAL_FILTERS";
export const MUTATION_SET_PROGRAM_ACTIVITIES =
  "MUTATION_SET_PROGRAM_ACTIVITIES";

export const MUTATION_SET_LEVEL_ACTIVITIES_MODAL_FILTERS =
  "MUTATION_SET_LEVEL_ACTIVITIES_MODAL_FILTERS";
export const MUTATION_SET_ALL_PROGRAM_ACTIVITIES_DETAIL =
  "MUTATION_SET_ALL_PROGRAM_ACTIVITIES_DETAIL";
export const MUTATION_SET_CALENDAR_PHASE_SELECTED_ID =
  "MUTATION_SET_CALENDAR_PHASE_SELECTED_ID";
export const MUTATION_SET_IS_LOADING_ACTIVITY_DATA =
  "MUTATION_SET_IS_LOADING_ACTIVITY_DATA";
export const GETTERS_IS_LOADING_ACTIVITY_DATA =
  "GETTERS_IS_LOADING_ACTIVITY_DATA";
export const MUTATION_SET_LES_MILLS_RESOURCE = "MUTATION_SET_LES_MILLS_RESOURCE";

export const ACTIVITIES_CONST = {
  TYPE: {
    ASSESSMENT: "ASSESSMENT"
  },
  SECONDARY_TYPE: {
    TOBACCO_ATTESTATION: "TOBACCO_ATTESTATION"
  },
  SIZE: {
    INDIVIDUAL: "individual",
    TEAM: "team",
    COMPANY: "company"
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/basic_activities/constants.js